<template>
  <div class="global-layout">
    <header class="global-header">
      <div class="global-brand">
        <img src="../assets/logo_igreja.png" alt="El Shaday" class="brand-logo" />
        <div>
          <h1>Painel global</h1>
          <span class="muted">ROOT · El Shaday</span>
        </div>
      </div>
      <div class="user-area">
        <span class="user-name">{{ adminName }}</span>
        <button class="logout-btn" @click="handleLogout">Sair</button>
      </div>
    </header>

    <main class="global-main">
      <router-view />
    </main>
  </div>
</template>

<script>
import { useAuthStore } from '../stores/auth'

export default {
  name: 'GlobalLayout',
  computed: {
    adminName() { return useAuthStore().adminName }
  },
  methods: {
    handleLogout() {
      const store = useAuthStore()
      store.logout()
      this.$router.replace('/login')
    }
  }
}
</script>

<style scoped>
.global-layout { min-height: 100vh; background: #f1f5f9; }
.global-header {
  background: #0f172a; color: white;
  padding: var(--spacing-base) var(--spacing-lg);
  display: flex; align-items: center; justify-content: space-between;
}
.global-brand { display: flex; align-items: center; gap: var(--spacing-sm); }
.brand-logo { width: 40px; height: 40px; }
.global-brand h1 { margin: 0; font-size: var(--text-md); }
.muted { color: #94a3b8; font-size: var(--text-sm); }
.user-area { display: flex; align-items: center; gap: var(--spacing-sm); }
.user-name { color: #cbd5e1; }
.logout-btn { background: transparent; color: white; border: 1px solid #475569; padding: 6px 12px; border-radius: var(--radius-md); cursor: pointer; }
.logout-btn:hover { background: #1e293b; }
.global-main { padding: 0; }
</style>
